import SplitScreenContent from "../../components/SplitScreenContent";

export const restaurationPorsche911 = {
  title: "Porsche-Restauration mit Stil, Substanz und Charakter",
  titleImageUrl: "porsche-engine.jpg",
  meta: {
    title:
      "Porsche Restauration 911, 964 & 993 – Karosserie, Motor & Interieur | WTM Sportwagen",
    description:
      "WTM Sportwagen steht für hochwertige Porsche-Restauration: Karosserieaufbau, Motorrevision, Interieur & Technik. F-Modell, G-Modell, 964, 993 – wir schaffen Porsche mit Seele.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323590/gallery/frank_kayser/M10_7558_taux5a.jpg",
      headline: "Porsche restaurieren heißt Werte erhalten",
      description:
        "Ein luftgekühlter Porsche ist mehr als ein Auto – er ist ein Stück Kultur. Unsere Restaurationen vereinen höchste handwerkliche Perfektion mit dem Ziel, dass Ihr Porsche nicht nur aussieht wie neu, sondern sich auch so fährt.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Porsche restaurieren heißt Werte erhalten",
      lead: "Ein luftgekühlter Porsche ist mehr als ein Auto – er ist ein Stück Kultur. Unsere Restaurationen vereinen höchste handwerkliche Perfektion mit dem Ziel, dass Ihr Porsche nicht nur aussieht wie neu, sondern sich auch so fährt.",
      highlight:
        "Jeder Porsche erzählt Geschichte – wir lassen sie neu aufleben.",
      spacing: "tight_top_comfortable_bottom",
      size: "lg",
      variant: "primary",
      margin: false,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/cars/911_sc_gulf/2_twzr5q",
      headline: "Porsche-Restauration bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Mehr als nur Reparatur – echte Restauration"
          intro="Bei WTM Sportwagen steht jede Porsche-Restauration für kompromisslose Qualität und handwerkliche Perfektion. Wir restaurieren nicht für das Museum, sondern für die Straße: fahrbar, ehrlich, emotional."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Persönlich & Transparent",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von Beginn an sind Sie Teil des Projekts: mit klarer Kommunikation, WhatsApp-Updates aus der Werkstatt und echtem persönlichen Austausch. So bleibt Ihre Restauration nachvollziehbar und vertrauensvoll.",
            },
            {
              type: "heading",
              text: "Moderne Interpretation mit Historie",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Ob F-Modell, G-Modell, 964 oder 993 – jede Restauration ist eine moderne Interpretation mit Respekt vor der Historie. Technisch überholt, optisch veredelt und fahrerisch perfekt abgestimmt.",
            },
            // {
            //   type: "component",
            //   component: "CallToActionWithModalV2",
            //   props: {
            //     headline: "Ihr Porsche – unsere Leidenschaft",
            //     paragraph:
            //       "Ob Komplett-Restauration oder gezielte Teilbereiche: Wir beraten Sie persönlich, ehrlich und kompetent. Auf Wunsch mit detaillierter Planung und Wertgutachten.",
            //     darkMode: false,
            //     margin: false,
            //   },
            // },
            // {
            //   type: "image",
            //   src: "gallery/cars/911_sc_gulf/1_kbqimx",
            //   alt: "Porsche Motorrevision im Rahmen der Restauration",
            //   width: 600,
            //   height: 400,
            //   highQuality: true,
            //   wrapperClass: "my-24",
            // },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Porsche-Restauration - Karosserie Detail",
      navbarHeight: 0,
    },
    {
      type: "lighthouse-grid",
      variant: "secondary",
      spacing: "comfortable",
      maxWidth: "none",
      showHeader: true,
      stickyHeadline: "Porsche 3.0 SC Targa",
      title: "Gallerie",
      subtitle: "Beispielprojekt",
      description:
        "Ein Blick hinter die Kulissen unserer Porsche-Restaurationen: Leidenschaft und Sorgfalt, mit der wir Klassiker wie F-Modell, G-Modell, 964 oder 993 wieder in Perfektion erstrahlen lassen. ",
      navbarHeight: 0,
      images: [
        {
          src: "gallery/cars/911_sc_gulf/2_twzr5q",
          alt: "Porsche Karosserie-Restauration Detail",
        },

        {
          src: "gallery/cars/911_sc_gulf/1_kbqimx",
          alt: "Porsche Motorrevision im Rahmen der Restauration",
        },
        {
          src: "gallery/cars/911_sc_gulf/3_qnjsla",
          alt: "WTM Porsche Werkstatt Restauration",
        },
        {
          src: "gallery/cars/911_sc_gulf/7_zzypzd",
          alt: "Porsche Backdate Umbau",
        },
        {
          src: "gallery/cars/911_sc_gulf/8_cbd5rx",
          alt: "Porsche Interieur Restauration Leder",
        },
        {
          src: "gallery/cars/911_sc_gulf/6_fx0eo5",
          alt: "Porsche Lackierung",
        },
        {
          src: "gallery/cars/911_sc_gulf/9_v2z2sk",
          alt: "Porsche Restauration",
        },
        {
          src: "gallery/cars/911_sc_gulf/1_ht482z",
          alt: "Porsche Karosserie-Restauration Detail",
        },

        {
          src: "gallery/cars/911_sc_gulf/3_inq0ak",
          alt: "Porsche Motorrevision im Rahmen der Restauration",
        },
        {
          src: "gallery/cars/911_sc_gulf/6b_uwiljb",
          alt: "WTM Porsche Werkstatt Restauration",
        },
        {
          src: "gallery/cars/911_sc_gulf/8_wcbdmq",
          alt: "Porsche Backdate Umbau",
        },
        {
          src: "gallery/cars/911_sc_gulf/2_yvwsps",
          alt: "Porsche Interieur Restauration Leder",
        },
        {
          src: "gallery/cars/911_sc_gulf/4_uc9r07",
          alt: "Porsche Lackierung",
        },
        {
          src: "gallery/cars/911_sc_gulf/5_yo1ri0",
          alt: "Porsche Restauration",
        },
        {
          src: "gallery/cars/911_sc_gulf/6_lkcmx2",
          alt: "Porsche Überrollbügel",
        },
        {
          src: "gallery/cars/911_sc_gulf/7_v87eqv",
          alt: "Porsche Restauration",
        },
      ],
      imageWidth: 800,
      imageCrop: "fill",
      imageGravity: "center",
      highQuality: true,
      showThumbnails: true,
    },

    {
      type: "cta-with-modal",
      headline: "Unverbindlich Restauration anfragen",
      paragraph:
        "Ein restaurierter Porsche ist eine Investition fürs Leben: Lassen Sie uns über Ihr Projekt sprechen. Wir melden uns persönlich und gehen alle Optionen mit Ihnen durch.",
      darkMode: true,
      spacing: "comfortable_top_tight_bottom",
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013424_2_tv8oqj",
      headline: "Restauration im Detail",
      rightContent: (
        <SplitScreenContent
          headline="Unser Fokus bei der Porsche-Restauration"
          intro="Restauration heißt für uns: Maßarbeit. Statt starrer Abläufe stehen die Individualität Ihres Porsche und Ihre Wünsche im Mittelpunkt – von originalgetreu über dezente Optimierungen bis zum kompromisslosen Backdate-Umbau."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Karosserieaufbau mit Perfektion",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Spaltmaßoptimierung, Blechneuanfertigung, Korrosionsschutz – jeder Arbeitsschritt folgt höchsten Standards. Präzision, die man sieht und fühlt.",
            },
            {
              type: "heading",
              text: "Motor- & Getriebeüberholung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Von originalgetreu bis Performance-orientiert – wir überholen Ihren Motor und Ihr Getriebe nach Ihren Wünschen und dem geplanten Einsatzzweck.",
            },
            {
              type: "heading",
              text: "Fahrwerksabstimmung",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Für Alltag, Landstraße oder Trackday – das Fahrwerk wird individuell auf Ihre Bedürfnisse und den Charakter des Fahrzeugs abgestimmt.",
            },
            {
              type: "heading",
              text: "Interieur in Manufakturqualität",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Lederarbeiten, Alcantara, Clubsport oder OEM-Look – das Interieur wird nach Ihren Wünschen in höchster Qualität gefertigt.",
            },
            {
              type: "heading",
              text: "Lackierung in jeder Qualitätsstufe",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Ob solide Standardlackierung, hochwertiges OEM+ Finish oder aufwendige Concours-Lackierung – wir bieten die passende Lösung für jedes Ziel. Dank unseres Netzwerks aus vertrauenswürdigen Spezialisten sind perfekte Ergebnisse garantiert.",
            },
            {
              type: "image",
              src: "gallery/frank_kayser/M10_6882_bvftmt",
              alt: "Porsche Restauration Motor",
              width: 600,
              height: 400,
              highQuality: true,
              wrapperClass: "my-24",
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Porsche-Restauration - Werkstatt Detail",
      navbarHeight: 0,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/frank_kayser/L1013428_1_ghbml3",
      headline: "Individuelle Porsche-Restauration",
      rightContent: (
        <SplitScreenContent
          headline="Jeder Porsche ein Unikat"
          intro="Wir arbeiten mit Feingefühl statt Dogma. Klassisch oder modern, Serie oder Clubsport – entscheidend ist, dass Ihr Porsche authentisch bleibt und Freude am Fahren schenkt."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Feingefühl statt Schema",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Unsere Restaurationen folgen keinem starren Schema. Sie entstehen aus dem Charakter des Autos und den Wünschen des Besitzers – immer mit Respekt vor der Historie.",
            },
            {
              type: "heading",
              text: "Umfangreiche Dokumentation",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Fotostrecken, Prüfprotokolle und Gutachten – jede Restauration wird lückenlos dokumentiert für langfristige Werterhaltung und Wertsteigerung.",
            },
            {
              type: "heading",
              text: "Deutschlandweiter Service",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Versicherter Hol- und Bringservice deutschlandweit, transparente Projektbegleitung mit regelmäßigen Updates und persönliche Betreuung von Anfang bis Ende.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum WTM Sportwagen?",
                items: [
                  "Versicherter Hol- und Bringservice deutschlandweit",
                  "Erfahrung mit luftgekühlten Porsche von 356 bis 993",
                  "Transparente Projektbegleitung mit regelmäßigen Updates",
                  "Langfristige Werterhaltung & Steigerung durch dokumentierte Restauration",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline:
                  "Jetzt Restauration besprechen – persönlich & unverbindlich",
                paragraph:
                  "Ob Komplett-Restauration oder gezielte Teilbereiche: Wir beraten Sie persönlich, ehrlich und kompetent. Auf Wunsch mit detaillierter Planung und Wertgutachten.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Porsche-Restauration - Lackierung Detail",
      navbarHeight: 0,
    },
    {
      type: "relevant-posts",
      postSlugs: [
        "porsche-restauration-ueberblick",
        "964-rsr-projekt",
        "911-targa-gulf",
      ],
      headline: "Werkstatt Journal: Porsche-Restauration im Detail",
      introText:
        "Entdecken Sie weitere Artikel zu Porsche Restauration, Motorrevision und Umbauten aus unserem Werkstatt Journal.",
      darkMode: false,
    },
  ],
};
